import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mui/material/Icon';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useNavigate } from 'react-router-dom';
import EditPNG from '../../assets/edit.svg';

ActionButton.propTypes = {
  id: PropTypes.number,
};

const styleButton = {
  cursor: 'pointer',
  width: '20px',
  color: '#535050',
  paddingLeft: '5px',
};
const iconButton = {
  display: 'inline-flex',
  cursor: 'pointer',
  marginLeft: '10px',
};

function ActionButton(props) {
  const { id = 0, displayCourierAction } = props;

  const navigate = useNavigate();
  const viewDetailAction = (e) => {
    e.preventDefault();
    navigate(`/dsp/${id}`);
  };
  const viewUsers = (e) => {
    e.preventDefault();
    displayCourierAction();
    navigate(`/dsp/users/${id}`);
  };
  return (
    <div>
      <ManageAccountsIcon onClick={viewUsers} style={styleButton} />
      <Icon onClick={viewDetailAction} style={iconButton}>
        <img src={EditPNG} style={styleButton} />
      </Icon>
    </div>
  );
}

export default ActionButton;
